export const getDiva = state => state.diva;
